import { ON_CONVERSATION_ENDED_EVENT_TYPE } from 'core/constants';
import { runListenersForEvent } from 'core_main/globals/events';
import { createEndConversationCallbackResponse } from 'core_main/sdk/end_conversation/helpers';
import { PubNubSessionEndMessageEvent } from '../types';

export const handleChatSessionEndedEvent = (
  message: PubNubSessionEndMessageEvent,
) => {
  const callbackResponse = createEndConversationCallbackResponse(message.data);

  runListenersForEvent(ON_CONVERSATION_ENDED_EVENT_TYPE, callbackResponse);
};
